// extracted by mini-css-extract-plugin
module.exports = {"card":"TinyOfferCard_card__2jszQ","offer-info":"TinyOfferCard_offer-info__1leQC","offer-price":"TinyOfferCard_offer-price__JYHUR","offer-image":"TinyOfferCard_offer-image__eIlDl"};